import axios from "axios";
import type { AxiosInstance } from "axios";
import { getLang } from "../i18n/lang";

export const baseURL = process.env.REACT_APP_API_URL;
export const digitalApiUrl = process.env.REACT_APP_DIGITAL_API_URL;
export const digitalAssetsUrl = process.env.REACT_APP_DIGITAL_ASSETS_URL;

/**
 * Rotas que já carregam o locale no caminho, como /pt_BR/banners.
 * O grupo 2 preserva o que vem depois (barra ou fim da string).
 */
const LOCALE_NA_ROTA = /^\/(pt_BR|en_US|pt_PT)(\/|$)/;

/**
 * Faz toda requisição sair no idioma escolhido pelo usuário.
 *
 * A API tem dois formatos de rota e cada um recebe o idioma de um jeito:
 *
 *   /pt_BR/banners      → troca o segmento: /en_US/banners
 *   /admin/banner       → acrescenta ?lang=en_US
 *
 * O parâmetro vai por `config.params` em vez de concatenado na URL porque
 * boa parte das chamadas já monta query string à mão — deixar o axios juntar
 * evita URL com dois "?" ou com "&" sobrando.
 *
 * Exportado para valer também nas instâncias de upload, que são criadas
 * separadas para não herdar o Content-Type JSON.
 */
export const aplicarIdioma = (instance: AxiosInstance): AxiosInstance => {
  instance.interceptors.request.use((config) => {
    const lang = getLang();

    if (!config.url) return config;

    if (LOCALE_NA_ROTA.test(config.url)) {
      config.url = config.url.replace(LOCALE_NA_ROTA, `/${lang}$2`);
      return config;
    }

    config.params = { ...(config.params || {}), lang };

    return config;
  });

  return instance;
};

export const api = aplicarIdioma(
  axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  }),
);